import React from 'react';
import PropTypes from 'prop-types';

const LoopPin = ({ outlineColor, s: { width, height } }) => (
  <svg width={width} height={height} viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={outlineColor}
      d="M40 16.2c-5 0-9 4.1-9 9s4.1 9 9 9 9-4.1 9-9-4-9-9-9zm0 16.9c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8z"
    />
    <path fill="transparent" d="M40 16.2c-5 0-9 4.1-9 9s4.1 9 9 9 9-4.1 9-9-4-9-9-9z" />
    <path
      fill={outlineColor}
      d="M52.4 12.9c-6.8-6.8-17.9-6.8-24.7 0s-5.1 17.8-.1 24.6l9.1 13.4c.2.3.6.4.9.2s.4-.6.2-.9l-9.1-13.4c-4.8-6.4-6.4-16.7-.1-23C31.6 10.7 35.7 9 40 9s8.4 1.7 11.5 4.7c6.3 6.3 4.7 16.6-.1 23L39.6 54.2l-.1.2c-1.7 2.5-4.4 3.9-7.4 3.9H10.5c-.3 0-.6.3-.6.6s.3.6.6.6H32c3.4 0 6.6-1.7 8.5-4.5l11.9-17.5c5.1-6.8 6.8-17.7 0-24.6z"
    />
    <path
      fill={outlineColor}
      d="M70.1 59.2c.1-.2.1-.3 0-.5 0-.1-.1-.1-.1-.2l-4.2-4.2c-.2-.2-.6-.2-.9 0s-.2.6 0 .9l3.1 3.1H44.2c-.3 0-.6.3-.6.6s.3.6.6.6H68l-3.1 3.1c-.2.2-.2.6 0 .9.1.1.3.2.4.2s.3-.1.4-.2l4.2-4.2c.1 0 .1 0 .2-.1z"
    />
    <path fill="transparent" d="M40 16.2c-5 0-9 4.1-9 9s4.1 9 9 9 9-4.1 9-9-4-9-9-9z" />
    <path
      fill="transparent"
      d="M51.5 13.8C48.4 10.7 44.3 9 40 9s-8.4 1.7-11.5 4.7c-6.3 6.3-4.7 16.6.1 23L40 53.6l-7-10.4 7 10.4 11.4-16.8c4.8-6.4 6.4-16.7.1-23zM40 34.3c-5 0-9-4.1-9-9s4.1-9 9-9 9 4.1 9 9-4 9-9 9z"
    />
  </svg>
);

LoopPin.defaultProps = {
  outlineColor: '#000000',
};

LoopPin.propTypes = {
  outlineColor: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
  }).isRequired,
};

export default LoopPin;
